import { render, staticRenderFns } from "./4gNavigation.vue?vue&type=template&id=11def1b5&scoped=true&"
import script from "./4gNavigation.vue?vue&type=script&lang=js&"
export * from "./4gNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11def1b5",
  null
  
)

export default component.exports